import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bioForUser } from '../../lib/userUtils.jsx';

const Bio = ({ authorized, user, obfuscateView }) => {
  if (obfuscateView) {
    return (
      <p className="blurry-text">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
        magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
        consequat.
      </p>
    );
  }
  return <p className="bio">{bioForUser(user, authorized)}</p>;
};

export default Bio;
